//=====================================================
//　G005：症状入力
//=====================================================

import { useHistory } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ReservationFlow, ProcessName } from "../../common/ReservationFlow";
import { ContentsTitle } from "../../common/ContentsTitle";
import { ReservationInfo } from "../../common/ReservationInfo";
import { TxtSymptoms } from "../../common/TxtSymptoms";
import { FormBox } from "../../common/FormBox";
import { BtnReturn } from "../../common/BtnReturn";
import { useAuth } from "../../utils/UseAuth";
import { useContext, useEffect } from "react";
import { CtxClinicInfo, CtxNewReservation } from "../../utils/Contexts";
import { useForm } from "react-hook-form";

export const FORM_NAME_SYMPTOMS = "input-symptoms";

export function G005(){

    const history = useHistory();
    const cnr = useContext(CtxNewReservation);
    const cci = useContext(CtxClinicInfo);
    const uf = useForm({reValidateMode: "onSubmit"});
    const ua = useAuth();

    // ブラウザバックで表示させない処理
    useEffect(function(){
        //タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 症状入力";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 症状入力";
        }
        
        // マウントフラグ
        let isMounted = true;
        
        // アンマウント時はstate(history)を更新しないようにする
        if(isMounted){
            // 完了データの場合、マイページ、トップ画面へ遷移
            if(cnr.data.done){
                if(ua.isLoggedIn()){
                    history.push('/mypage');
                } else {
                    history.push('/');
                }
            }
        }

        // cleanup関数(Unmount時の処理)
        return () => {
            // マウントオフ
            isMounted = false;
        }
        // アンマウント時にのみ一回だけ実行したいため第2引数指定なし。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //バリデーション通過時処理
    function FormSubmit(){
        cnr.update({symptoms: uf.getValues(FORM_NAME_SYMPTOMS)});
        history.push("/reservation/confirm");
    }

    //バリデーションエラー時処理
    function FormError(){
        //コンテキスト内容の症状が正常値の場合しか設定されない。
        //そのため、入力エラー時に異常入力値がコンテキストに保持されるようにするための処理
        cnr.update({symptoms: uf.getValues(FORM_NAME_SYMPTOMS)});
    }

    //初期値表示
    useEffect(function(){
        if (cnr){
            if (cnr.data.symptoms){uf.setValue(FORM_NAME_SYMPTOMS, cnr.data.symptoms)}
        }
    },[cnr,uf]);

    return (
        <>
            <ReservationFlow currentProcess={ProcessName.Symptoms}/>
            <ContentsBox>
                <ReservationInfo />
            </ContentsBox>
            <ContentsBox>
                <ContentsTitle title="症状を入力してください" />
                <FormBox useForm={uf} successFunc={FormSubmit} errorFunc={FormError}  >
                    <TxtSymptoms name={FORM_NAME_SYMPTOMS} />
                    <BtnSubmit title="次へ" />
                </FormBox>
            </ContentsBox>
            <BtnReturn />
        </>
    );

}
